<template lang="pug">
    Row(style="background-color: #eee;padding:20px" type="flex" justify="space-between")
        LoginCard(v-for="item in loginCardItems" :key="item.name" :groupName="groupName" :disabled="disabled" :item="item" @updateCurrentUse="updateCurrentUse($event)"  @updateConfig="updateConfig($event)" :currentuse="value.currentuse" @getCustomizeImg="getPrefsByType('customize')" @updatePrefs="getPrefs()" :isCleared="isCleared" @clearImgEvent="isCleared = $event")

</template>
<script>
import LoginCard from "./LoginPageCard";
import { getGroupPrefs, getGroupLoginPageLayout, updateCustomizeLoginPageLayout } from "@/api/group";

export default {
    components: { LoginCard },
    props: ["value", "groupName", "disabled"],
    data() {
        return {
            imageMapByType: {
                default: {},
                customize: {}
            },
            layoutMapByType: {
                default: {},
                customize: {}
            },
            descriptionMapByType: {
                default: "",
                customize: ""
            },
            loginPageImageKey: ["loginbackgroundUrl", "loginlogoUrl"],
            valueHasChanged: false,
            isCleared: false
        };
    },
    watch: {
        value: {
            deep: true,
            handler: function(newVal, oldVal) {
                // console.log(newVal);
                // this.applyConfig = this.isApplyDefault ? this.defaultConfig : newVal;
            },
            immediate: true //初始化頁面後立即監聽
        }
    },
    computed: {
        customizeConfig: {
            get() {
                // console.log(this.value.config);
                return this.value.config;
            },
            set() {}
        },
        defaultConfig: {
            get() {
                return {
                    loginlogo: 0,
                    loginbackground: 0,
                    layout: 0,
                    logindescription: ""
                };
            },
            set() {}
        },
        loginCardItems: {
            get() {
                return [
                    {
                        name: this.$i18n.t("groupPattern.default"),
                        value: 0,
                        canEdit: false,
                        config: this.defaultConfig,
                        buttonText: this.isApplyDefault
                            ? this.$i18n.t("groupPattern.applied")
                            : this.$i18n.t("groupPattern.apply"),
                        contentStyle: {
                            overflow: "hidden",
                            display: "flex",
                            "justify-content": "center",
                            "align-items": "center",
                            background: `url(${this.imageMapByType.default.loginbackgroundUrl}) no-repeat center center/cover`
                        },
                        loginDescription: this.descriptionMapByType.default,
                        layout: this.layoutMapByType.default,
                        loginbackgroundUrl: this.imageMapByType.default.loginbackgroundUrl,
                        logoUrl: this.imageMapByType.default.loginlogoUrl
                    },
                    {
                        name: this.$i18n.t("groupPattern.customize"),
                        value: 1,
                        canEdit: true,
                        config: this.customizeConfig,
                        buttonText: !this.isApplyDefault
                            ? this.$i18n.t("groupPattern.applied")
                            : this.$i18n.t("groupPattern.apply"),
                        contentStyle: {
                            overflow: "hidden",
                            display: "flex",
                            "justify-content": "center",
                            "align-items": "center",
                            background: `url(${
                                this.customizeConfig.loginbackground == 0
                                    ? this.imageMapByType.default.loginbackgroundUrl
                                    : this.imageMapByType.customize.loginbackgroundUrl
                            }) no-repeat center center/cover`
                        },
                        loginDescription: this.customizeConfig.logindescription,
                        layout:
                            this.customizeConfig.layout == 0
                                ? this.layoutMapByType.default
                                : this.layoutMapByType.customize,
                        loginbackgroundUrl:
                            this.customizeConfig.loginbackground == 0
                                ? this.imageMapByType.default.loginbackgroundUrl
                                : this.imageMapByType.customize.loginbackgroundUrl,
                        logoUrl:
                            this.customizeConfig.loginlogo == 0
                                ? this.imageMapByType.default.loginlogoUrl
                                : this.imageMapByType.customize.loginlogoUrl
                    }
                ];
            },
            set(newVal) {
                this.loginCardItems = newVal;
            }
        }
    },
    methods: {
        updateCurrentUse(value) {
            // console.log(value, "updateCurrentUse");
            this.$emit("updateLoginPage", value);
        },
        updateConfig(config) {
            // console.log(config);
            this.$emit("updateLoginPageConfig", config);
        },
        getPrefsByType(type) {
            // console.log("get");
            getGroupPrefs({ type: type, groupName: this.groupName })
                .then(result => {
                    this.imageMapByType[type] = result.data.img;
                    this.descriptionMapByType[type] = result.data.loginDescription;
                    this.isCleared = false;
                    // console.log(type, result.data.loginDescription, this.descriptionMapByType, "descriptionMapByType");
                })
                .catch(err => {});
        },
        getLayoutByType(type) {
            getGroupLoginPageLayout({ type: type, groupName: this.groupName })
                .then(result => {
                    this.layoutMapByType[type] = result.data.loginPageCss;
                })
                .catch(err => {});
        },
        getPrefs() {
            this.getPrefsByType("default");
            this.getPrefsByType("customize");

            this.getLayoutByType("default");
            this.getLayoutByType("customize");
        }
    },
    mounted() {
        this.getPrefs();
    }
};
</script>


// WEBPACK FOOTER //
// src/components/GroupPatternFormItems/LoginPageSelector.vue